import { Text, Center, Button, Image } from "@chakra-ui/react";
import EmptyImage from "../../assets/empty2.svg";
import { useSchoolsContext } from "../../Contexts/schoolContext";
interface Props {
  message?: string;
  description?: string;
  buttonText?: string;
  handleClick?: () => void;
  hasButton?: boolean;
  height?: string;
  hidePicture?: boolean;
}
export default function Empty({
  message,
  buttonText,
  handleClick,
  hasButton,
  height,
  hidePicture,
  description,
}: Props) {
  const { school } = useSchoolsContext();
  return (
    <Center h={height || "100%"} flexDir={"column"} gap={5}>
      {!hidePicture && (
        <Image
          opacity={"0.5"}
          src={EmptyImage}
          w={"300px"}
          filter="grayscale(100%)"
        />
      )}
      <Text textAlign={"center"} opacity={"0.5"}>
        {message || "Nothing to see here"}
      </Text>
      <Text fontSize="sm" textAlign={"center"} opacity={"0.5"}>
        {description}
      </Text>
      {hasButton && (
        <Button
          colorPalette={school?.accentColor}
          variant={"ghost"}
          onClick={handleClick}
        >
          {buttonText}
        </Button>
      )}
    </Center>
  );
}
